export default __webpack_public_path__ + "48d1cafba7b04928f453180507de511a.png";